import { SvgIcon, Tooltip } from '@mui/material';
import { AutorenewIconStyles, MiniButtonStyles } from './styles';
import { CustomButtomProps } from './types';

export const MiniButton: React.FC<CustomButtomProps> = ({
  handleClick,
  icon,
  text,
  disabled = false,
  $backgroundColor,
  $outline = false,
  option,
  selectValue,
  'data-testid': dataTestId,
  isLoading,
}) => {
  return (
    <MiniButtonStyles
      $backgroundColor={$backgroundColor}
      $outline={$outline}
      disabled={disabled}
      onClick={() => handleClick?.()}
      className={selectValue === option ? 'select-item' : ''}
      data-testid={dataTestId}
    >
      {text}

      {isLoading ? (
        <Tooltip title="Donwload de arquivo em andamento..">
          <span>
            <AutorenewIconStyles />
          </span>
        </Tooltip>
      ) : (
        icon && <SvgIcon component={icon} />
      )}
    </MiniButtonStyles>
  );
};
